import { Switch } from "./Switch";
import React  from "react";

export const ToggleInput = ({ name, data, values = [0, 1] }) => {
  return <Switch id={name} data={data} name={name} values={values} />;
};
